import React from 'react';

/**
 * 自动续费服务规则 - 英文版
 */
const EN: React.FC = () => {
  return (
    <div className="mx-auto max-w-4xl px-6 py-12">
      <h1 className="mb-8 text-4xl font-bold text-gray-900">Automatic Renewal Service Rules</h1>

      <div className="mb-6 text-sm text-gray-600">
        <p>
          <strong>Release Date:</strong> 2026/3/20
        </p>
        <p>
          <strong>Effective Date:</strong> 2026/3/20
        </p>
      </div>

      <div className="mb-8">
        <p className="font-semibold">
          This Automatic Renewal Service Rules (hereinafter referred to as &quot;the Rules&quot;)
          shall be deemed as a supplementary agreement of the &quot;CodeFlicker Subscription
          Services Agreement&quot; and shall be an integral part of the CodeFlicker Subscription
          Services Agreement. If there is any conflict between the Rules and the CodeFlicker
          Subscription Services Agreement, the Rules shall prevail.
        </p>
        <p className="mt-4">
          When purchasing paid services of CodeFlicker, if you confirm that you have selected &quot;
          Monthly Subscription &quot; or &quot; Quarterly Subscription &quot; or &quot; Yearly
          Subscription &quot; and agreed to CodeFlicker Subscription Services Agreement by checking
          the box or continue to operate (including but not limited to clicking to agree, or
          continue to purchase, or complete the payment, or use of paid service), you shall be
          deemed to agree to this Rules.
        </p>
      </div>

      <div className="space-y-8 text-gray-700">
        <section>
          <p className="mb-[10px] leading-relaxed">You understand and agree that:</p>
          <h2 className="mb-4 text-2xl font-semibold text-gray-900">
            1. Description of Automatic Renewal Service
          </h2>
          <p className="leading-relaxed">
            This Automatic Renewal Service is based on your need for automatic renewal. Under the
            premise of your subscription of CodeFlicker Subscription, the Automatic Renewal Service
            is a service launched to prevent any loss due to your negligence or failure to renew the
            Subscription service in time for any other reasons. If you choose to use the Automatic
            Renewal Service, you authorize the Company, when the automatic renewal billing cycle for
            the Paid Service subscribed is about to expire, to authorize the payment channel (such
            as checkout) to deduct the Service Fee for the next billing cycle from the balance of
            your payment account bound with your User Account for purchase of Paid Service. You
            acknowledge that the billing cycle may be determined by the payment channel at its sole
            discretion in accordance with the actual situation. Once the automatic payment is
            successfully made, your subscription for Paid Service is continuous until you cancel the
            automatic renewal service or such the subscription service is suspended, discontinued or
            terminated in accordance with the CodeFlicker Terms of Use.
          </p>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-semibold text-gray-900">
            2. Type of Automatic Renewal Service
          </h2>

          <div className="space-y-4">
            <div>
              <p className="leading-relaxed">
                <strong>2.1</strong> Currently, continuous Subscription subscriptions includes
                &quot;Monthly Subscription&quot;, &quot;Quarterly Subscription&quot; and
                &quot;Yearly Subscription&quot;.
              </p>
              <p className="mt-2 leading-relaxed">
                The specific Subscription and its corresponding Subscription benefits are subject to
                announcements made on the relevant pages of the Website from time to time and the
                service benefits expressly specified on the Website at the time of your actual
                subscription.
              </p>
            </div>

            <div>
              <p className="leading-relaxed">
                <strong>2.2</strong> The Company may add and adjust types of Automatic Renewal
                Service and contents of benefits of Automatic Renewal Service according to business
                development and changes in users' demands. Please refer to the contents and detailed
                description displayed on the specific interface when subscribe the Paid Service.
              </p>
            </div>
          </div>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-semibold text-gray-900">
            3. Automatic Renewal Service Billing Rules
          </h2>

          <div className="space-y-4">
            <div>
              <p className="leading-relaxed">
                <strong>3.1</strong> If you choose the Automatic Renewal Service, you agree that the
                payment channel may automatically deduct the Service Fees of the next billing cycle
                from the payment account bound with your User Account, without verifying the
                password of CodeFlicker Subscription Account, password of payment account, payment
                password or any other information;
              </p>
            </div>

            <div>
              <p className="leading-relaxed">
                <strong>3.2</strong> Unless you cancel the Automatic Renewal Service voluntarily or
                the Company cancels the Automatic Renewal Service on its own initiative, the
                Automatic Renewal Service will be renewed and deducted automatically without any
                limit on the times;
              </p>
            </div>

            <div>
              <p className="leading-relaxed">
                <strong>3.3</strong> If you fail to cancel the Automatic Renewal Service, you shall
                be deemed to have agreed that the Company may automatically deduct the service fees
                within a certain period after the expiry of the corresponding Automatic Renewal
                billing cycle in accordance with the rules or policies of the payment channel.
              </p>
            </div>

            <div>
              <p className="leading-relaxed">
                <strong>3.4</strong> Upon successful completion of the automatic renewal payment,
                the Company will automatically extend your subscription to the Paid Service by the
                billing cycle you selected when activating the automatic renewal service. In the
                event that the fees cannot be deducted normally due to force majeure (e.g., network
                disruption or other unforeseen circumstances) prior to the end of the previous
                billing cycle, the deduction will be postponed until successful completion.
              </p>
              <p className="mt-2 leading-relaxed">
                Please ensure your payment account has sufficient balance. You are responsible for
                any risks and/or losses resulting from renewal failure due to issues with your
                payment account or insufficient funds.
              </p>
            </div>
          </div>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-semibold text-gray-900">4. Automatic Renewal Notice</h2>
          <p className="leading-relaxed">
            In order for you to know the situation of Automatic Renewal, we and the payment channels
            will send to you an Automatic Renewal Notice or other methods prior to the expiration
            date of the Automatic Renewal Service you have selected (the notice from the payment
            channel shall be subject to the actual implementation by the operator of the payment
            channel).
          </p>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-semibold text-gray-900">5. Price adjustment</h2>
          <p className="leading-relaxed">
            Please note that the Company reserves the right to adjust the prices of Automatic
            Renewal Service. During the term of your Automatic Renewal Service, if the Company
            adjusts the price of paid service corresponding to your Automatic Renewal Service, the
            Company will notify you thereof by reasonable methods product interface publication,
            platform announcement or in-site messages. The adjusted price will take effect on the
            date of the adjustment or as otherwise notified by the Company. If you disagree with the
            price adjustment, you may choose to cancel the Automatic Renewal Service in accordance
            with the Rules, and your Paid Service subscription will expire at the end of the current
            billing cycle. Importantly, to ensure your continued Subscription benefits, the Company
            will not revoke the automatic deduction authorization with the payment channel until you
            explicitly cancel the Automatic Renewal Service.
          </p>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-semibold text-gray-900">
            6. Unsubscription Instructions
          </h2>
          <p className="leading-relaxed">
            You shall have the right to choose whether to continue to use or cancel the Automatic
            Renewal Service. If you choose to cancel the Automatic Renewal Service, you shall cancel
            the subscription prior to the expiration date of the Automatic Renewal billing cycle you
            select. The specific requirements for the cancellation date shall be determined by, and
            subject to, the information provided via the product interface, platform announcements,
            in notifications, email notifications, or other communications from the Company. After
            the cancellation, the term of the Paid Service you subscribe will expire from the
            expiration date of the current billing cycle. If you fail to cancel the subscription in
            a timely manner, the payment channel will continue to deduct the service fee for the
            next and the subsequent billing cycle, and the term of the Paid Services will be
            postponed to the expiration date of the next billing cycle. Please note that the
            cancellation date may be subject to the rules of certain payment channels. For example,
            if you cancel within 48 hours prior to the end of the current billing cycle for an
            Automatic Renewal Service, such payment channels may have already processed the
            deduction for the service fee for the next billing cycle. Where such deduction has been
            successfully completed, the paid service you have purchased will remain available until
            the end of that next billing cycle. The specific deduction rules are subject to the
            information displayed on the relevant page where you activate the auto-renewal feature.
          </p>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-semibold text-gray-900">7. Unsubscription way</h2>
          <p className="leading-relaxed">You can unsubscribe in the following way：</p>
          <p className="leading-relaxed text-gray-800">
            Please complete the unsubscribe process on the official website. The specific steps are:
            On the homepage, click [User center] - [Plan management] -[Cancel Renewal].
          </p>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-semibold text-gray-900">
            8. The Service policy adjustment
          </h2>
          <p className="leading-relaxed">
            The Company shall have the right to stop providing you with the Automatic Renewal
            Service based on its operation strategy, and shall send notice to you by platform
            publication, in-site messages and other methods prior to the termination of such
            Automatic Renewal Service. The term of the Paid Service you subscribe shall expire from
            the expiration date of the current Automatic Renewal billing cycle.
          </p>
        </section>
      </div>
    </div>
  );
};

export default EN;
